import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import io from 'socket.io-client';

const SearchPosts = () => {
  const [posts, setPosts] = useState([]);
  const [filters, setFilters] = useState({ type: '', roleNeeded: '', query: '' });
  const navigate = useNavigate();
  const socket = io(process.env.REACT_APP_API_URL.replace('http', 'ws'));

  useEffect(() => {
    fetchPosts();

    socket.on('newPost', (newPost) => {
      setPosts((prev) => [newPost, ...prev]);
    });

    socket.on('postUpdated', (updatedPost) => {
      setPosts((prev) => prev.map(p => p._id === updatedPost._id ? updatedPost : p));
    });

    return () => socket.disconnect();
  }, []);

  const fetchPosts = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}oosh/service/search-posts`, {
        params: filters,
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      });
      setPosts(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters({ ...filters, [name]: value });
    fetchPosts();
  };

  const handleSearch = (e) => {
    if (e.key === 'Enter') fetchPosts();
  };

  return (
    <div className="max-w-4xl mx-auto p-6 bg-white shadow-md rounded-lg">
      <h2 className="text-2xl font-bold mb-6 text-blue-600">Search Service Posts</h2>
      <div className="mb-6 grid grid-cols-1 md:grid-cols-3 gap-4">
        <select
          name="type"
          value={filters.type}
          onChange={handleFilterChange}
          className="p-2 border rounded-md focus:ring-2 focus:ring-blue-500"
        >
          <option value="">All Types</option>
          <option value="service">Service</option>
          <option value="supply">Supply</option>
        </select>
        <select
          name="roleNeeded"
          value={filters.roleNeeded}
          onChange={handleFilterChange}
          className="p-2 border rounded-md focus:ring-2 focus:ring-blue-500"
        >
          <option value="">All Roles</option>
          <option value="contractor">Contractor</option>
          <option value="serviceprovider">Service Provider</option>
          <option value="supplier">Supplier</option>
        </select>
        <input
          type="text"
          name="query"
          value={filters.query}
          onChange={handleFilterChange}
          onKeyPress={handleSearch}
          placeholder="Search by title, description, or location..."
          className="p-2 border rounded-md focus:ring-2 focus:ring-blue-500"
        />
      </div>
      <div className="space-y-4">
        {posts.map((post) => (
          <div
            key={post._id}
            onClick={() => navigate(`/post/${post._id}`)}
            className="p-4 border rounded-lg hover:bg-gray-100 cursor-pointer"
          >
            <h3 className="text-lg font-semibold">{post.title}</h3>
            <p className="text-gray-600">{post.description.substring(0, 100)}...</p>
            <p className="text-sm text-gray-500">Type: {post.type}, Role: {post.roleNeeded}</p>
            <p className="text-sm text-gray-500">Budget: ${post.budget}, Location: {post.location}</p>
            <p className="text-sm text-gray-500">Posted by: {post.clientId?.firstName} {post.clientId?.lastName}</p>
            <p className="text-sm text-gray-500">Date: {new Date(post.createdAt).toLocaleDateString()}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SearchPosts;